<div class="rating">
	<div *ngFor="let star of stars; let i = index" class="rating-star">
		<span
			class="ion rating-star-icon"
			[ngClass]="{
				'ion-md-star': highlight(i),
				selected: highlight(i),
				'ion-md-star-outline': !highlight(i)
			}"
			(click)="starSelect(i + 1)"
			(mouseenter)="starMouseEnter(i)"
			(mouseleave)="starMouseLeave()"
		></span>
	</div>
</div>
